/**
 * Cue sheet for the video opening cinematic (public/ui/cine/intro.mp4, 16 s, rendered by
 * art/ux/cine/render.mjs). The video has no audio track: music, SFX and the narrator are played
 * live by the audio engine in sync with video.currentTime (respects volume settings).
 * Shots: 0 lab · 2.5 inventor · 4.7 ray charging · 6.5 misfire · 7.6 flash · 8.2 primordial ocean ·
 * 10.6 underwater · 12.6 the cell → white.
 */
import type { NarratorMood, SfxName } from '@core/services';

export const VIDEO_DURATION = 16;

export const VIDEO_LINES: Array<{ at: number; end: number; text: string; mood: NarratorMood }> = [
  { at: 0.4, end: 3.5, text: 'Behold! The evolution ray. One zap and anything climbs the tree of life.', mood: 'excited' },
  { at: 3.9, end: 6.3, text: 'Just needs a teeny bit more power— *burp*', mood: 'snark' },
  { at: 8.6, end: 10.9, text: 'Oh no. That was the REVERSE setting.', mood: 'alarm' },
  { at: 12.7, end: 15.6, text: 'Welcome to the bottom of the tree, little cell. Chop chop.', mood: 'snark' },
];

export const VIDEO_SFX: Array<{ at: number; name: SfxName; volume?: number; pitch?: number }> = [
  { at: 0.15, name: 'portal', volume: 0.25, pitch: 0.55 },
  { at: 4.7, name: 'powerup', volume: 0.8, pitch: 0.8 },
  { at: 5.5, name: 'burp', volume: 0.7 },
  { at: 5.7, name: 'zap', volume: 0.45 },
  { at: 6.2, name: 'zap', volume: 0.6, pitch: 1.2 },
  { at: 6.5, name: 'zap', volume: 1 },
  { at: 6.55, name: 'portal', volume: 0.8 },
  { at: 7.6, name: 'impact', volume: 1 },
  { at: 7.65, name: 'evolve', volume: 0.7, pitch: 0.6 },
  { at: 8.75, name: 'thunder', volume: 0.85 },
  { at: 9.95, name: 'thunder', volume: 0.6 },
  { at: 10.65, name: 'splash', volume: 0.8 },
  { at: 11.2, name: 'bubble', volume: 0.6 },
  { at: 11.9, name: 'bubble', volume: 0.5, pitch: 1.3 },
  { at: 12.7, name: 'bubble', volume: 0.5 },
  { at: 13.4, name: 'growth', volume: 0.45 },
  { at: 15.1, name: 'evolve', volume: 0.75 },
];
